// src/components/App2.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Para redirecionar o usuário

const App2 = ({ appRoute = 'app2' }) => { 
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`http://131.255.179.139:5353/${appRoute}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data); // Dados do app carregados com sucesso
      } catch (err) {
        if (err.response && err.response.status === 403) {
          setError('Acesso negado. Você não tem permissão para acessar este aplicativo.');
          // Opção: redirecionar o usuário para a página de login ou outra página
          navigate('/');
        } else {
          setError('Ocorreu um erro ao carregar o aplicativo.');
        }
      }
    };

    fetchData();
  }, [appRoute, navigate]);

  if (error) {
    return <div>{error}</div>; // Exibe a mensagem de erro
  }

  if (!data) {
    return <div>Carregando...</div>; // Exibe um estado de carregamento
  }

  return (
    <div style={{ height: '100vh', width: '100vw', margin: 0, padding: 0, position: 'relative', overflow: 'hidden' }}>
      <iframe
        src="http://131.255.179.139:3535/"
        style={{
          border: 'none',      // Remove borda do iframe
          width: '100vw',      // Ocupe 100% da largura da viewport
          height: '100vh',     // Ocupe 100% da altura da viewport
          margin: 0,           // Remove margens
          padding: 0,          // Remove preenchimentos
          display: 'block',    // Garante que o iframe seja um bloco sem espaços ao redor
        }}
        title="App Externo"
      ></iframe>
    </div>
  );
};

export default App2;